import { memberAdapter } from '@/services/adapters/member'

export const notificationAdapter = (data) => {
  const member = memberAdapter(data)
  return {
    ...member,
    type: data.type,
    seen: data.seen,
    createdAt: data.createdAt,
  }
}
